import { NotificationTypes } from "@store/types/notificationTypes";

export const notificationInitial: NotificationTypes = {
  amountNewNotice: 0,
  amountNewSilent: 0,
  amountNewLostWill: 0
}